export const APP_INIT = 'APP_INIT'
export const APP_SET_SIGN_IN_MODAL_STATE = 'APP_SET_SIGN_IN_MODAL_STATE'
